import ProductList, { ProductListProps } from "./ProductList";
export default ProductList;
export { ProductListProps };
